// src/app/admindashobard/components/AdminProfileMenu.jsx

import * as React from "react";
import {
  Avatar,
  Box,
  Divider,
  Menu,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

import { Colors } from "../../utils/Colors";
import { ROUTES } from "../../shared/constants/routes";

export default function AdminProfileMenu({
  anchorEl,
  open,
  onClose,
}) {
  const navigate = useNavigate();

  const handleProfileClick = () => {
    onClose();
    navigate(ROUTES.ADMIN_DASHBOARD);
  };

  const handleSettingsClick = () => {
    onClose();
    navigate(ROUTES.SETTINGS);
  };

  const handleLogoutClick = () => {
    onClose();

    // optional: clear auth data here
    localStorage.removeItem("token");
    localStorage.removeItem("access");
    localStorage.removeItem("refresh");
    localStorage.removeItem("user");

    navigate(ROUTES.AUTH_LOGIN);
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      transformOrigin={{ horizontal: "right", vertical: "top" }}
      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      PaperProps={{
        elevation: 8,
        sx: {
          mt: 1.5,
          width: 320,
          borderRadius: 3,
          overflow: "hidden",
          border: `1px solid ${Colors.border.light}`,
          boxShadow: "0 14px 30px rgba(0,0,0,0.12)",
        },
      }}
    >
      <Box sx={{ px: 3, py: 2.5 }}>
        <Stack direction="row" spacing={1.5} alignItems="center">
          <Avatar
            sx={{
              width: 54,
              height: 54,
              bgcolor: "#d6d6d6",
              color: "#ffffff",
              fontWeight: 700,
            }}
          >
            F
          </Avatar>

          <Box>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: 22,
                color: Colors.brand.primary,
                lineHeight: 1.15,
              }}
            >
              Fludee Admin
            </Typography>
            <Typography
              sx={{
                fontSize: 15,
                color: Colors.text.sub,
                mt: 0.3,
              }}
            >
              Super Admin
            </Typography>
          </Box>
        </Stack>
      </Box>

      <Divider />

      <Box sx={{ py: 1.2 }}>
        <MenuItem
          onClick={handleProfileClick}
          sx={{
            px: 3,
            py: 1.8,
            gap: 1.8,
            fontSize: 18,
            color: Colors.text.header,
          }}
        >
          <PersonOutlineRoundedIcon sx={{ color: "#7e7e7e" }} />
          Profile
        </MenuItem>

        <MenuItem
          onClick={handleSettingsClick}
          sx={{
            px: 3,
            py: 1.8,
            gap: 1.8,
            fontSize: 18,
            color: Colors.text.header,
          }}
        >
          <SettingsRoundedIcon sx={{ color: "#7e7e7e" }} />
          Settings
        </MenuItem>
      </Box>

      <Divider />

      <Box sx={{ py: 1.2 }}>
        <MenuItem
          onClick={handleLogoutClick}
          sx={{
            px: 3,
            py: 1.8,
            gap: 1.8,
            fontSize: 18,
            color: Colors.text.header,
          }}
        >
          <LogoutRoundedIcon sx={{ color: "#7e7e7e" }} />
          Logout
        </MenuItem>
      </Box>
    </Menu>
  );
}